import * as React from "react";

function RoboCupIntro() {
  return (
    <section className="trps-section trps-paper trps-robocup" id="RoboCup">
      <div className="trps-wrap--wide">
        <h2 className="trps-h">RoboCupとは</h2>

        <div className="trps-robocup__grid">
          <div className="trps-robocup__copy">
            <p className="trps-robocup__lead">
              RoboCupは、競技を通じてAIとロボティクスを進歩させる国際的な科学プロジェクトです。
              2050年までに、人間のサッカー世界王者に勝つ自律型ロボットチームの実現を目指しています。
            </p>

            <div className="trps-robocup__ssl">
              <h3>Small Size League</h3>
              <p>
                TRAPSが挑むSSLでは、フィールド上部のカメラがロボットとボールを捉え、
                各チームのAIが状況を判断します。複数のロボットが連携し、パス、守備、
                シュートを自律的に組み立てます。
              </p>
            </div>
          </div>

          <div className="trps-robocup__videos">
            <div className="trps-video-embed">
              <iframe
                src="https://www.youtube-nocookie.com/embed/a-yG4ydWZ4Q?rel=0"
                title="RoboCup紹介動画"
                loading="lazy"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
              />
            </div>
            <div className="trps-video-embed">
              <iframe
                src="https://www.youtube-nocookie.com/embed/FG8CocoRuqY?rel=0"
                title="RoboCup 2026 Incheon SSL Division B 決勝"
                loading="lazy"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default RoboCupIntro;
